import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Typography, Box, Grid } from '@mui/material';

const CoverPage = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1, p: 2 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 8 }}>
                        <Typography variant="h5">
                        Shop Smart. Ship Fast. Stay Canadian.
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 2 }}>
                        CCOO.ca is a Canadian-based e-commerce brand specializing in curated, high-quality products sold exclusively through Amazon. With a focus on simplicity, trust, and national pride, CCOO.ca brings together everyday essentials and standout finds — all backed by fast shipping, reliable service, and a distinctly Canadian identity.
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 2 }}>
                        Whether it's home goods, lifestyle accessories, or seasonal must-haves, CCOO.ca is your go-to destination for shopping smart, shipping fast, and staying proudly Canadian.
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 2 }}>
                        Experience the convenience of online shopping with the assurance of Canadian values. Welcome to CCOO.ca — where quality meets reliability, and every purchase supports local.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>

                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default CoverPage;